const clientsTestIDs = {
  clientsScreen: 'clients-screen',
  clientsToContactLeaveFeedbackButton: 'feedback-leave-button',
  clientsToContactLeaveFeedbackDescription: 'feedback-description',
};

export default clientsTestIDs;
